import React, { useCallback, useState } from 'react';
import { Box, Button } from '@mui/material';
import AddAttendeeModal from './AddAttendeeModal/AddAttendeeModal';
import PresidingChairModal from './PresidingChairModal';

import styles from './AttendanceTableActions.module.scss';

const AttendanceTableActions: React.FunctionComponent = () => {
  const [addAttendeeModalOpen, setAddAttendeeModalOpen] = useState<boolean>(false);
  const [presidingChairModalOpen, setPresidingChairModalOpen] = useState<boolean>(false);

  const handleAddAttendeeModalOpen = useCallback(() => {
    setAddAttendeeModalOpen(true);
  }, []);

  const handleAddAttendeeModalClose = useCallback(() => {
    setAddAttendeeModalOpen(false);
  }, []);

  const handlePresidingChairModalOpen = useCallback(() => {
    setPresidingChairModalOpen(true);
  }, []);

  const handlePresidingChairModalClose = useCallback(() => {
    setPresidingChairModalOpen(false);
  }, []);

  return (
    <>
      <Box className={styles.buttonGroup}>
        <Button variant="contained" color="primary" onClick={handleAddAttendeeModalOpen}>
          Add Attendee
        </Button>
        <Button variant="contained" color="primary" onClick={handlePresidingChairModalOpen}>
          Set Presiding Chair
        </Button>
      </Box>
      <AddAttendeeModal
        open={addAttendeeModalOpen}
        onClose={handleAddAttendeeModalClose}
        onSubmit={handleAddAttendeeModalClose}
      />
      <PresidingChairModal
        open={presidingChairModalOpen}
        onClose={handlePresidingChairModalClose}
        onSubmit={handlePresidingChairModalClose}
      />
    </>
  );
};

export default AttendanceTableActions;
